export const toAmount = (value) => {
  const parsed = Number(value || 0);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const parseAmountInput = (value, defaultValue = 0) => {
  const normalized = String(value ?? '')
    .trim()
    .replace(/[$,%\s]/g, '')
    .replace(',', '.');
  const parsed = Number(normalized);

  if (!Number.isFinite(parsed)) {
    return defaultValue;
  }

  return parsed;
};

export const toPositiveInt = (value, fallback = 1) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return fallback;
  }

  const rounded = Math.floor(parsed);
  return rounded > 0 ? rounded : fallback;
};
